import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import CheckIcon from '@mui/icons-material/Check';
import { styled } from '@mui/system';
import { useDispatch, useSelector } from 'react-redux';
import { getSuccessContent, getSuccessOpen, setSuccessContent, setSuccessOpen } from './app/appSlice';

const CustomSnackbar = styled(Snackbar)(({ theme }) => ({
    '& .MuiSnackbarContent-root': {
        backgroundColor: '#2196F3', // Adjust this color as needed
        color: 'white',
        display: 'flex',
        alignItems: 'center',
    },
    '& .MuiSnackbarContent-message': {
        display: 'flex',
        alignItems: 'center',
    },
}));

function SuccessSnackbar() {
    const dispatch = useDispatch();
    const successOpen = useSelector(getSuccessOpen);
    const successContent = useSelector(getSuccessContent);

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        dispatch(setSuccessOpen(false));
        dispatch(setSuccessContent(""));
    };

    return (
        <div>
            <CustomSnackbar
                open={successOpen}
                autoHideDuration={3000}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                message={
                    <span style={{ display: 'flex', alignItems: 'center' }}>
                        <CheckIcon style={{ color: "green", margin: '0px 8px 0px 0px' }} />
                        {successContent}
                    </span>
                }
            />
        </div>
    );
}

export default SuccessSnackbar;
